import BaseClient from '@/app/model/api/response/baseApiClient'

class WeedGrowthApi extends BaseClient {
  public getWeedGrowth (fieldId: number, plantingId: number) {
    const path = '/v1/weed-growth/' + fieldId + '/' + plantingId
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new WeedGrowthApi()
